var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "tabs-container" },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%" },
                attrs: { type: "card" },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "自定义控件", name: "customComponent" } },
                  [_c("custom-component")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: "标准控件-element",
                      name: "standardComponent"
                    }
                  },
                  [_c("standard-component")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: { lazy: true, label: "通知提示", name: "notifyTips" }
                  },
                  [_c("notify-tips")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: { lazy: true, label: "国际化demo", name: "i18nDemo" }
                  },
                  [_c("i18n-demo")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: "国际化工具",
                      name: "langTools"
                    }
                  },
                  [_c("lang-tools")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: { lazy: true, label: "XML转JSON", name: "xmlToJson" }
                  },
                  [_c("xml-to-json")],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }